// src/components/HeroCarousel.js
import React from 'react';
import { Carousel } from 'react-bootstrap';

import "../css/styles.css"
import "../css/Montserrat.css"
import "../css/Roboto.css"
import "../js/scripts.js"
import "../css/Course.css"

const images = [
  '/cover/Cover2.JPG',
  '/cover/Cover3.jpeg',
  '/cover/Cover5.jpg',
  '/cover/Cover6.jpeg',
  '/cover/Cover8.JPG',
  '/cover/Cover9.jpg',
  '/cover/Cover10.jpg',
  '/cover/Cover11.jpeg',
  '/cover/Cover12.jpeg'
];

const HeroCarousel = () => {
  return (
    <Carousel fade interval={3000} className='masterhead'>
      {images.map((image, index) => (
        <Carousel.Item key={index}>
          <header className="masthead" style={{backgroundImage:`url(${image})`}}>
                <div className="container">
                    <div className="masthead-subheading">Welcome To Master Leadership!</div>
                    <div className="masthead-heading text-uppercase">Empower, Inspire, Lead.</div>
                    <a className="btn btn-primary btn-xl text-uppercase" href="#about">Tell Me More</a>
                </div>
            </header>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default HeroCarousel;
